import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

/**
 * Wrap any route that requires authentication.
 * - While the auth session is being restored from storage, renders nothing
 *   so there is no flash-redirect to /auth/login.
 * - Once initialisation is complete, allows access only if a token exists;
 *   otherwise redirects to /auth/login, preserving the intended destination.
 */
const ProtectedRoute = ({ children }) => {
  const { state } = useAuth();
  const location  = useLocation();

  // Wait for the stored-session check to finish before making a decision
  if (state.isInitializing) {
    return null;
  }

  if (!state.isAuthenticated || !state.token) {
    return (
      <Navigate
        to="/auth/login"
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;
